import { styled } from '@mui/material/styles';
import Tab from '@mui/material/Tab';

const StyledTab = styled((props) => <Tab {...props} />)(
    ({ theme }) => ({
        marginRight: '12px',
        minHeight: '20px',
        backgroundColor: '#F2F8FB',
        borderRadius: '4px',
        color: '#288FF9',
        fontSize: '16px',
        lineHeight: '20px',
        fontWeight: 600,
        fontStyle: 'normal',
        textAlign: 'center'
    }),
);

const HourAvailable = ({ hour, click }) => {
    return (
        <StyledTab onClick={click} label={hour} />
    );
}

export default HourAvailable;